var _path, _path2, _path3, _rect, _rect2, _rect3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHistory(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 14C13 12.3431 14.3431 11 16 11H34.8889C36.5457 11 37.8889 12.3431 37.8889 14V36C37.8889 37.6569 36.5457 39 34.8889 39H16C14.3431 39 13 37.6569 13 36V14Z",
    stroke: "#F1BF70",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.1113 17.2215C23.1113 15.9329 24.1555 14.8887 25.4451 14.8887C26.7328 14.8887 27.778 15.9329 27.778 17.2215C27.778 18.5102 26.7328 19.5553 25.4451 19.5553C24.1555 19.5553 23.1113 18.5102 23.1113 17.2215Z",
    stroke: "#F1BF70",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5557 24.2223V23.4162C21.7054 21.2609 23.3778 19.5557 25.4446 19.5557C27.5124 19.5557 29.1848 21.2609 29.3334 23.4162V24.2223",
    stroke: "#F1BF70",
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 17.4443,
    y: 25.7773,
    width: 16,
    height: 1.55556,
    fill: "#F1BF70"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 17.4443,
    y: 29.667,
    width: 16,
    height: 1.55556,
    fill: "#F1BF70"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 17.4443,
    y: 33.5557,
    width: 16,
    height: 1.55556,
    fill: "#F1BF70"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistory);
export default __webpack_public_path__ + "static/media/history.5b2cc07030f30f417c150b6d532485b8.svg";
export { ForwardRef as ReactComponent };